import { useEffect, useMemo, useRef, useState } from "react";
import { io } from "socket.io-client";

// Verbindet sich mit dem Memo-Multiplayer-Server und haelt den kompletten
// Spielzustand vom Server. Der Client rechnet selbst nichts aus - er zeigt
// nur an, was der Server schickt, und meldet Klicks zurueck.
export default function useMemoryMultiplayer({ aktiv, name, serverUrl }) {
   const [verbunden, setVerbunden] = useState(false);
   const [zustand, setZustand] = useState(null);
   const [fehler, setFehler] = useState(null);
   const socketRef = useRef(null);

   useEffect(() => {
      if (!aktiv || !name) return;

      const socket = io(serverUrl, { withCredentials: true });
      socketRef.current = socket;

      socket.on("connect", () => {
         setVerbunden(true);
         setFehler(null);
         socket.emit("memo:join", { name });
      });
      socket.on("disconnect", () => setVerbunden(false));
      socket.on("connect_error", (err) => setFehler(err.message));
      socket.on("memo:state", setZustand);

      return () => {
         socket.close();
         socketRef.current = null;
         setVerbunden(false);
         setZustand(null);
         setFehler(null);
      };
   }, [aktiv, name, serverUrl]);

   const aktionen = useMemo(
      () => ({
         starten: (deck) => socketRef.current?.emit("memo:start", { deck }),
         aufdecken: (uid) => socketRef.current?.emit("memo:flip", uid),
         zuruecksetzen: () => socketRef.current?.emit("memo:reset"),
      }),
      [],
   );

   return { verbunden, zustand, fehler, ...aktionen };
}
